import { GridColumnHeader, textNumberConstraints, textNumberMatchModes } from '../models/grid-column-header';

export const vendorBooleanColumn = [
  'isCustomer',
  'customerPOManualRouting',
  'isAutoposting',
  'nonpoAllowed',
  'autoRTV',
  'interCompany',
];

export const vendorInfoHeaders: GridColumnHeader[] = [
  {
    field: 'system',
    order: 2,
    title: 'System',
    type: 'systemDropdown',
    width: '150px',
    required: true,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'companyCode',
    order: 3,
    title: 'Company Code',
    type: 'companyCodeDropdown',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'vendorERPID',
    order: 4,
    title: 'Vendor ERP ID',
    type: 'autoComplete',
    width: '150px',
    required: true,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'name',
    order: 5,
    title: 'Vendor Name',
    type: 'string',
    width: '150px',
    required: false,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'isCustomer',
    order: 6,
    title: 'Customer',
    type: 'boolean',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'customerPOManualRouting',
    order: 7,
    title: 'Cust PO Manual Routing',
    type: 'boolean',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'interCompany',
    order: 8,
    title: 'Inter Company',
    type: 'boolean',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'daysDelay',
    order: 9,
    title: 'Days Delay',
    type: 'string',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'autoRTV',
    order: 10,
    title: 'Auto RTV',
    type: 'boolean',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'isAutoposting',
    order: 11,
    title: 'Verification Required',
    type: 'boolean',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'nonpoAllowed',
    order: 12,
    title: 'Non PO Allowed',
    type: 'boolean',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'taxcode',
    order: 13,
    title: 'Tax Code',
    type: 'string',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'vendorGroup',
    order: 14,
    title: 'Vendor Group',
    type: 'vendorGroupDropdown',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
];

export const paymentCodeInfoHeaders: GridColumnHeader[] = [
  {
    field: 'system',
    order: 1,
    title: 'System',
    type: 'string',
    width: '150px',
    required: true,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'companyCode',
    order: 2,
    title: 'Company Code',
    type: 'companyCodeDropdown',
    width: '150px',
    required: true,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'country',
    order: 3,
    title: 'Country',
    type: 'string',
    width: '150px',
    required: true,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'name',
    order: 4,
    title: 'Name',
    type: 'string',
    width: '250px',
    required: true,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'paymentCode',
    order: 5,
    title: 'Payment Code',
    type: 'number',
    width: '150px',
    required: true,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },

  {
    field: 'paymentMethod',
    order: 6,
    title: 'Payment Method',
    type: 'string',
    width: '150px',
    required: true,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'vendorERPID',
    order: 7,
    title: 'Vendor ERPID',
    type: 'autoComplete',
    width: '150px',
    required: true,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
];

export const lineItemsHeaders: GridColumnHeader[] = [
  {
    field: 'docItemNumber',
    order: 1,
    title: 'Doc Item No',
    type: 'string',
    width: '10px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'purchaseOrder',
    order: 1,
    title: 'PO',
    type: 'string',
    width: '150px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'purchaseOrderItem',
    order: 2,
    title: 'PO Item',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'amount',
    order: 3,
    title: 'Amount',
    type: 'number',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'quantity',
    order: 4,
    title: 'Quantity',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'taxCode',
    order: 5,
    title: 'Tax Code',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'material',
    order: 6,
    title: 'Material',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'itemText',
    order: 7,
    title: 'Item Text',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'unitOfMeasure',
    order: 8,
    title: 'Unit of Measure',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'deliveryNote',
    order: 9,
    title: 'Delivery Note',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'conditionType',
    order: 10,
    title: 'Condition Type',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'counter',
    order: 11,
    title: 'Counter',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'vendor',
    order: 12,
    title: 'Vendor',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'grCreator',
    order: 13,
    title: 'GR Creator',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'grCreatorEmail',
    order: 14,
    title: 'GR Creator Email',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'refDocument',
    order: 15,
    title: 'Ref Doc',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'refDocFiscalYear',
    order: 16,
    title: 'Ref Doc Fiscal Year',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'refDocLineItem',
    order: 17,
    title: 'Ref Doc LineItem',
    type: 'string',
    width: '150px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'exception',
    order: 18,
    title: 'Exception',
    type: 'string',
    width: '300px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
];

export const glEntryHeaders: GridColumnHeader[] = [
  {
    field: 'docItemNumber',
    order: 1,
    title: 'Doc Item No',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'glAccount',
    order: 2,
    title: 'GL Account',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'glAcName',
    order: 3,
    title: 'GL Acct Name',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'debitCredit',
    order: 4,
    title: 'Debit/Credit',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'amount',
    order: 5,
    title: 'Amount',
    type: 'number',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'itemText',
    order: 6,
    title: 'Item Text',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'taxCode',
    order: 7,
    title: 'Tax Code',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'assignment',
    order: 8,
    title: 'Assignment',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'costCenter',
    order: 9,
    title: 'Cost Center',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'costCenterName',
    order: 10,
    title: 'Cost Center Name',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'profitCenter',
    order: 11,
    title: 'Profit Center',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'wbsElement',
    order: 12,
    title: 'WBS Element',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'tradingPartner',
    order: 13,
    title: 'Trading Partner',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
];

export const custWBGLEntryHeaders: GridColumnHeader[] = [
  {
    field: 'docItemNumber',
    order: 1,
    title: 'Doc Item No',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'amount',
    order: 2,
    title: 'Amount',
    type: 'number',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'taxCode',
    order: 3,
    title: 'Tax Code',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'debitCredit',
    order: 4,
    title: 'Debit/Credit',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'itemText',
    order: 5,
    title: 'Item Text',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'activityType',
    order: 6,
    title: 'Activity Type',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'glAccount',
    order: 7,
    title: 'GL Account',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'profitCenter',
    order: 9,
    title: 'Profit Center',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
];

export const custNWEGLEntryHeaders: GridColumnHeader[] = [
  {
    field: 'docItemNumber',
    order: 1,
    title: 'Doc Item No',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'amount',
    order: 2,
    title: 'Amount',
    type: 'number',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'taxCode',
    order: 3,
    title: 'Tax Code',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'debitCredit',
    order: 4,
    title: 'Debit/Credit',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'itemText',
    order: 5,
    title: 'Item Text',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'glAccount',
    order: 6,
    title: 'GL Account',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'wbsElement',
    order: 7,
    title: 'WBS Element',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'assignment',
    order: 8,
    title: 'Assignment',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'costCenter',
    order: 9,
    title: 'Cost Center',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'profitCenter',
    order: 10,
    title: 'Profit Center',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'copaLevel7',
    order: 11,
    title: 'COPA Level 7',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'copaLevel8',
    order: 12,
    title: 'COPA Level 8',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
];

export const retrievalGLEntryHeaders: GridColumnHeader[] = [
  {
    field: 'docItemNumber',
    order: 1,
    title: 'Doc Item No',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'glAccount',
    order: 2,
    title: 'GL Account',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'glAcName',
    order: 3,
    title: 'GL Acct Name',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'debitCredit',
    order: 4,
    title: 'Debit/Credit',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'amount',
    order: 5,
    title: 'Amount',
    type: 'number',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'taxCode',
    order: 6,
    title: 'Tax Code',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'itemText',
    order: 7,
    title: 'Item Text',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'assignment',
    order: 8,
    title: 'Assignment',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'costCenter',
    order: 9,
    title: 'Cost Center',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'costCenterName',
    order: 10,
    title: 'Cost Center Name',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'profitCenter',
    order: 11,
    title: 'Profit Center',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'wbsElement',
    order: 12,
    title: 'WBS Element',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'tradingPartner',
    order: 13,
    title: 'Trading Partner',
    type: 'string',
    width: '100px',
    required: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'activityType',
    order: 14,
    title: 'Activity Type',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'copaLevel7',
    order: 15,
    title: 'Copa Level 7',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'copaLevel8',
    order: 16,
    title: 'Copa Level 8',
    type: 'string',
    width: '100px',
    required: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
];

export const substitutionHeaders: GridColumnHeader[] = [
    {
    field: 'fromEmail',
    order: 1,
    title: 'User',
    type: 'email',
    width: '150px',
    required: true,
    disabled: true,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'toEmail',
    order: 1,
    title: 'Substitute User',
    type: 'email',
    width: '150px',
    required: true,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'startDate',
    order: 2,
    title: 'Start Date',
    type: 'date',
    width: '150px',
    required: true,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'endDate',
    order: 3,
    title: 'End Date',
    type: 'date',
    width: '150px',
    required: false,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
  {
    field: 'comments',
    order: 4,
    title: 'Comments',
    type: 'string',
    width: '250px',
    required: true,
    disabled: false,
    filterOptions: [],
    selectedValues: [],
    advancefilter: {
      isAdvanceFilterUsed: false,
      operator: 'and',
      matchModeOptions: [...textNumberMatchModes],
      constraints: textNumberConstraints.map((c) => ({ ...c })),
    },
  },
];
